export enum UserPageEnum {
  UserCreate = 'UserCreate',
}
